module.exports = __webpack_public_path__ + "static/media/answerPage.4db84df3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage.png
// module id = 1723
// module chunks = 0 1